/**
 * CalendarLegend Component
 *
 * Legend showing calendar status colors.
 */

import React from 'react';

export const CalendarLegend: React.FC = () => {
  const items = [
    { label: 'Available', color: 'bg-white border border-gray-200' },
    { label: 'Blocked', color: 'bg-gray-100' },
    { label: 'Booked', color: 'bg-blue-100' },
    { label: 'Pending', color: 'bg-yellow-100' },
    { label: 'Custom price', color: 'bg-green-100' },
    { label: 'Selected', color: 'bg-primary-100 border-2 border-primary-500' },
  ];

  return (
    <div className="flex flex-wrap gap-4 p-4 bg-white rounded-xl border border-gray-200">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          <div className={`w-4 h-4 rounded ${item.color}`} />
          <span className="text-sm text-gray-600">{item.label}</span>
        </div>
      ))}
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-green-500" />
        <span className="text-sm text-gray-600">Check-in</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-red-500" />
        <span className="text-sm text-gray-600">Check-out</span>
      </div>
    </div>
  );
};

export default CalendarLegend;
